import {
  IApplication,
  IApplicationContact,
} from "@rentiohq/shared-frontend/dist/types/application.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { IAction } from "@rentiohq/web-shared/dist/types";
import utils from "@rentiohq/web-shared/dist/utils";
import * as t from "../../../../../services/translationService";

export enum EPdfStatus {
  Checking = "checking",
  Generating = "generating",
  Generated = "generated",
  NotAvailable = "not_available",
}

export const getViewActions = (params: {
  item: IApplication;
  pdfStatus: EPdfStatus;
  setQueryParamValue: (params: { applicationId: string }) => void;
  isDetailView?: boolean;
}) => {
  const { item, pdfStatus, setQueryParamValue, isDetailView } = params;

  const result: IAction[] = [];

  if (!isDetailView) {
    result.push({
      content: getLocalizedText("view.application"),
      onClick: () => {
        setQueryParamValue({
          applicationId: item.id,
        });
      },
    });
  }

  if (item.pdfUrl) {
    result.push({
      content: getLocalizedText(`application.pdf.status.${pdfStatus}`),
      isDisabled: pdfStatus !== EPdfStatus.Generated,
      // Open the candidate's CV/PDF in a new tab instead of navigating the
      // whole app away to the file.
      onClick: () => window.open(`${item.pdfUrl}`, "_blank"),
    });
  }

  return result;
};

export const getContactActions = (params: {
  item: IApplication;
  contact?: IApplicationContact;
}) => {
  const { item, contact: contactParam } = params;

  const result: IAction[] = [];

  const contactOptions = ["phone", "email"];

  for (const contact of contactParam ? [contactParam] : item.contacts) {
    for (const key in contact) {
      if (contact.hasOwnProperty(key) && contactOptions.includes(key)) {
        let title: string | undefined;
        let link: string | undefined;

        // @ts-ignore
        const value = contact[key];

        switch (key) {
          case "phone":
            if (value) {
              title = `${t.callImperative()} ${
                contact.firstname
              } (${utils.phone.parsePhoneNumber(value)})`;
              link = `tel:${value}`;
            }

            break;

          case "email":
            if (value) {
              title = `${t.mailImperative()} ${contact.firstname} (${value})`;
              link = `mailto:${value}`;
            }
            break;

          default:
            break;
        }

        if (title && link) {
          result.push({
            content: title,
            onClick: () => {
              if (link) {
                window.location.href = link;
              }
            },
          });
        }
      }
    }
  }

  return result;
};
